 <template>
  <div class="recordBody">
    <!-- 记录列表 -->
    <!-- <el-button
      size="mini"
      style="border-color: #5474e6; background: #5474e6"
      type="primary"
      @click="addDialogVisible = true"
      >创建</el-button
    > -->
    <div class="line" v-for="(item, index) in list" :key="index">
      <div class="rowTop">
        <div style="display: flex">
          <div style="padding-right: 20px" v-if="item.Type == 4">
            {{ item.Type == 4 ? item.CycleName : "" }}
          </div>
          <div>
            {{ item.Type == 5 ? item.Time : "" }}
          </div>
        </div>
        <div>{{ item.Operator }}</div>
      </div>
      <div class="rowCenter">
        {{ item.Title == "封面" ? "" : index + "." }}{{ item.Title }}
      </div>
      <div class="rowBottom">
        <div class="status">{{ item.Status == 1 ? "已完成" : "未完成" }}</div>
        <!--  -->
        <div style="display: flex">
          <div
            style="color: #4083fe; padding: 10px"
            v-if="item.IsWrite == 1 && item.Status == 0"
            @click="record(item)"
            class="btn"
          >
            去记录
          </div>
          <div
            style="color: #4083fe; padding: 10px"
            v-if="item.IsWrite == 1 && item.Status != 0"
            @click="record(item)"
            class="btn"
          >
            修改
          </div>
          <div
            style="color: #4083fe; padding: 10px"
            v-if="item.Status == 1"
            @click="look(item)"
            class="btn"
          >
            查看
          </div>
        </div>
      </div>
    </div>
    <!--  -->

    <!-- 去记录 -->
    <el-dialog
      :close-on-click-modal="false"
      @closed="clearAddFrom"
      :title="recordInfo.Title"
      :visible.sync="recordDialogVisible"
      :width="
        typeNum == 4 || typeNum == 5 || typeNum == 11 || typeNum == 12
          ? '80%'
          : '800px'
      "
    >
      <!-- 观察记录表（学期） -->
      <div v-if="typeNum == 4">
        <!-- 表格 -->
        <div class="table" v-if="tableData.list.length != 0">
          <div class="tableHeader row">
            <div class="lineOne cell">纬度</div>
            <div class="lineTwo cell">要素</div>
            <div class="lineThere cell">观察点</div>
          </div>
          <div
            class="row"
            v-for="(row, indexRow) in tableData.list"
            :key="indexRow"
          >
            <div class="lineOne cell border_right border_left border_bottom">
              {{ row.Name }}
            </div>
            <div style="flex: 1">
              <div
                style="display: flex"
                v-for="(twoLine, twoLineIndex) in row.info"
                :key="twoLineIndex"
              >
                <div class="cell border_bottom border_right lineTwo">
                  {{ twoLine.Name }}
                </div>
                <div class="lineThere">
                  <div
                    class="cell"
                    v-for="(ThereLine, ThereLineIndex) in twoLine.info"
                    :key="ThereLineIndex"
                  >
                    <div
                      style="flex: 1"
                      class="border_bottom border_right textHiddent"
                    >
                      <el-popover
                        placement="top-start"
                        title="内容"
                        width="200"
                        trigger="hover"
                        :content="ThereLine.Name"
                      >
                        <p slot="reference" style="margin: 0">
                          {{ ThereLine.Name }}
                        </p>
                      </el-popover>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(item, index) in tableData.cycleWrites" :key="index">
          <div class="tableHeader row">{{ item.Title }}</div>
          <div>
            <el-input
              type="textarea"
              :rows="4"
              :placeholder="
                item.Title == '故事描述'
                  ? '输入提示：1、我看到了什么？2、我看到了哪些细节（孩子语言、行为、表情等'
                  : item.Title == '分析'
                  ? '输入提示：1、孩子行为产生的原因是什么？2、孩子可以从中获得哪些经验？'
                  : item.Title == '支持'
                  ? '输入提示：1、他能自己解决吗？需要我介入吗？2、如果需要，我可以采用什么方式方法？'
                  : '请输入内容'
              "
              v-model="item.Desc"
              maxlength="500"
              show-word-limit
            ></el-input>
          </div>
        </div>
      </div>
      <!--  观察记录表（过程） -->
      <div v-if="typeNum == 5 && tableData.list.length != 0">
        <div
          class="table"
          v-for="(row, indexRow) in tableData.list"
          :key="indexRow"
        >
          <div class="tableHeader row">
            <div class="lineOne cell"></div>
            <div class="lineTwo cell" style="width: 165px"></div>
            <div class="lineThere cell">观察点</div>
            <div class="grade cell">经常发生</div>
            <div class="grade cell">偶尔发生</div>
            <div class="grade cell">从未发生</div>
          </div>
          <div class="row">
            <div class="lineOne cell border_right border_left border_bottom">
              {{ row.Name }}
            </div>
            <div style="flex: 1">
              <div
                style="display: flex"
                v-for="(twoLine, twoLineIndex) in row.info"
                :key="twoLineIndex"
              >
                <div
                  class="cell border_bottom border_right lineTwo"
                  style="width: 165px"
                >
                  {{ twoLine.Name }}
                </div>
                <div class="lineThere">
                  <div
                    class="cell"
                    v-for="(ThereLine, ThereLineIndex) in twoLine.info"
                    :key="ThereLineIndex"
                  >
                    <div
                      style="flex: 1"
                      class="border_bottom border_right textHiddent"
                    >
                      <el-popover
                        placement="top-start"
                        title="内容"
                        width="200"
                        trigger="hover"
                        :content="ThereLine.Name"
                      >
                        <p slot="reference" style="margin: 0">
                          {{ ThereLine.Name }}
                        </p>
                      </el-popover>
                    </div>
                    <div
                      class="grade cell border_bottom border_right"
                      @click="check(indexRow, twoLineIndex, ThereLineIndex, 1)"
                    >
                      <span v-if="ThereLine.Value == 1" class="check"></span>
                      <span v-else class="noCheck"></span>
                    </div>
                    <div
                      class="grade cell border_bottom border_right"
                      @click="check(indexRow, twoLineIndex, ThereLineIndex, 2)"
                    >
                      <span v-if="ThereLine.Value == 2" class="check"></span>
                      <span v-else class="noCheck"></span>
                    </div>
                    <div
                      class="grade cell border_bottom border_right"
                      @click="check(indexRow, twoLineIndex, ThereLineIndex, 3)"
                    >
                      <span v-if="ThereLine.Value == 3" class="check"></span>
                      <span v-else class="noCheck"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="textareaTitle">{{ row.Title }}</div>
          <div>
            <el-input
              type="textarea"
              :rows="4"
              :placeholder="
                row.Title == '故事描述'
                  ? '输入提示：1、我看到了什么？2、我看到了哪些细节（孩子语言、行为、表情等'
                  : row.Title == '分析'
                  ? '输入提示：1、孩子行为产生的原因是什么？2、孩子可以从中获得哪些经验？'
                  : row.Title == '支持'
                  ? '输入提示：1、他能自己解决吗？需要我介入吗？2、如果需要，我可以采用什么方式方法？'
                  : '请输入内容'
              "
              v-model="row.Describe"
              maxlength="500"
              show-word-limit
            ></el-input>
          </div>
        </div>
        <div class="textareaTitle">
          {{ tableData.Title }}：<span @click="AutoCustomerContent()">
            自动生成</span
          >
        </div>
        <div>
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="tableData.CustomerSay"
            maxlength="500"
            show-word-limit
          ></el-input>
        </div>
      </div>
      <!-- 成长记录表1 -->
      <div v-if="typeNum == 11">
        <el-row class="demo-el-row">
          <el-col :span="12">
            <div class="demo-el-col dark bd-top bd-bottom bd-left bd-right">
              <el-row style="display: flex">
                <el-col :span="6" style="margin-right: 20px">
                  <el-input
                    v-model="tableParams.titleTab1"
                    placeholder="姓名"
                  ></el-input>
                </el-col>
                <el-col :span="17">
                  <el-input
                    v-model="tableParams.name"
                    placeholder="请输入内容"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-top bd-bottom bd-right">
              <el-row style="display: flex">
                <el-col :span="6" style="margin-right: 20px">
                  <el-input
                    v-model="tableParams.titleTab2"
                    placeholder="内容"
                  ></el-input>
                </el-col>
                <el-col :span="17">
                  <el-input
                    v-model="tableParams.content"
                    placeholder="请输入内容"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-bottom bd-left bd-right">
              <el-row style="display: flex">
                <el-col :span="8" style="margin-right: 20px">
                  <el-input
                    v-model="tableParams.titleTab3"
                    placeholder="观察日期"
                  ></el-input>
                </el-col>
                <el-col :span="17">
                  <el-input
                    v-model="tableParams.looktime"
                    placeholder="请输入内容"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-bottom bd-right">
              <el-row style="display: flex">
                <el-col :span="6" style="margin-right: 20px">
                  <el-input
                    v-model="tableParams.titleTab4"
                    placeholder="记录人"
                  ></el-input>
                </el-col>
                <el-col :span="17">
                  <el-input
                    v-model="tableParams.writename"
                    placeholder="请输入内容"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col v-for="(item, index) in tableParams.List" :key="index">
            <div
              class="demo-el-col light bd-left bd-bottom bd-right"
              style="height: 129px; flex-direction: column"
            >
              <el-row
                style="display: flex; width: 100%; flex-direction: column"
              >
                <el-col :span="6" style="margin: 10px 0 10px 0">
                  <input
                    v-model="item.title"
                    style="font-size: 14px; color: #000; padding-left: 15px"
                    placeholder="请输入标题"
                  />
                </el-col>
                <el-col :span="24">
                  <el-input
                    style="font-size: 14px"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="item.desc"
                  >
                  </el-input>
                </el-col>
              </el-row>
              <!-- <input v-model="item.title" class="table-textarea" />
              <textarea
                v-model="item.desc"
                type="textarea"
                class="table-textarea"
                style="height: 80px; border: 0; outline: none; resize: none"
                oninput="if(value.length>140)value=value.slice(0,140)"
              /> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 成长记录表2 -->
      <div v-if="typeNum == 12">
        <div class="table-header">
          <el-row class="demo-el-row">
            <el-col>
              <div
                class="demo-el-col dark bd-top bd-bottom bd-left bd-right"
                style="justify-content: center"
              >
                <input
                  type="text"
                  v-model="params.title"
                  class="input-table"
                  placeholder="例:成长记录(四月)"
                  style="text-align: center"
                />
              </div>
            </el-col>
            <el-col :span="12">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  表现
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  真棒
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  较好
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left bd-right">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  加油
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            class="demo-el-row"
            v-for="(item, index) in params.List"
            :key="index"
          >
            <el-col :span="12">
              <div class="demo-el-col dark bd-bottom bd-left">
                <el-input
                  type="textarea"
                  v-model="item.manifestation"
                  class="input-table"
                  placeholder="请输入表现行为"
                  style="width: 100%; border: none"
                />
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 1
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/stateHui.png')
                    "
                    @click="onClickRate(1, index)"
                    style="width: 26px; height: 26px"
                    alt=""
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 2
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/stateHui.png')
                    "
                    lazy-load
                    style="width: 26px; height: 26px"
                    mode=""
                    @click="onClickRate(2, index)"
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left bd-right">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 3
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/stateHui.png')
                    "
                    lazy-load
                    style="width: 26px; height: 26px"
                    mode=""
                    @click="onClickRate(3, index)"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 图文板式 视频 体检 运动 -->
      <div
        v-if="
          typeNum == 6 ||
          typeNum == 7 ||
          typeNum == 8 ||
          typeNum == 9 ||
          typeNum == 1 ||
          typeNum == 10 ||
          typeNum == 13
        "
      >
        <record-plate
          :TeacherId="info.TeacherId"
          :CustomerId="info.CustomerId"
          :tempDetailId="editFrom.Id"
          :TempId="info.TempId"
          v-if="recordDialogVisible"
          @IsChange="record_plate_change"
          :Answer="editFrom.Answer"
          :PlateId="recordInfo.PlateId"
          :typeNum="typeNum"
          :Content="editFrom.Content"
          :title="recordInfo.Title"
        />
      </div>

      <!--  -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false">返 回</el-button>
        <el-button type="primary" @click="addFn(0)">保存草稿</el-button>
        <el-button type="primary" @click="addFn(1)">完成</el-button>
      </span>
    </el-dialog>

    <!-- 新增 -->
    <!-- :title="moduleId == '' ? '新增' : '修改'" -->
    <el-dialog
      @closed="clearAddFrom"
      title="新增"
      :visible.sync="addDialogVisible"
      width="30%"
    >
      <div>
        <div class="inputBox">
          <div class="label">类型：</div>
          <el-select
            v-model="addFrom.type"
            @change="typeChange"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in TenantTempType"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 学期评价出现学期 -->
        <div class="inputBox" v-if="addFrom.type == 4">
          <div class="label">学期：</div>
          <el-select
            v-model="addFrom.cycleId"
            :disabled="info.cycleId ? false : true"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in CycleList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 过程评价出现时间 -->
        <div class="inputBox" v-if="addFrom.type == 5">
          <div class="label">时间：</div>
          <el-date-picker
            v-model="addFrom.time"
            style="width: 193px"
            size="mini"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <div class="inputBox">
          <div class="label">名称：</div>
          <el-input
            size="mini"
            style="width: 193px"
            v-model="addFrom.title"
          ></el-input>
        </div>

        <div class="inputBox">
          <div class="label">排序值：</div>
          <el-input-number
            size="mini"
            style="width: 193px"
            :min="0"
            v-model="addFrom.orderSort"
          ></el-input-number>
        </div>
        <div class="inputBox">
          <div class="label">操作人身份：</div>
          <el-select
            v-model="addFrom.operator"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in TenantTempOperatorList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFnMoudle">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 
 <script>
import recordPlate from "./recordPlate.vue";
import {
  WriteTempDetailList,
  GetTenantTempTypeInfo,
  GetCycleInfoSelectResult,
  GetTenantTempOperatorInfo,
  GoTenantTempDetailOneInfoByImgTextRecord,
  GoTenantTempDetailOneInfoByCycleWrite,
  GoTenantTempDetailOneInfoByCycleWriteCycle,
  AutoCustomerContent,
  SaveDetailInfo,
  GetGrowthQuestion,
} from "@/api/api";
export default {
  data() {
    return {
      tableData: {
        list: [],
        CustomerSay: "",
        Title: "",
        cycleWrites: [],
      },
      recordDialogVisible: false,
      addDialogVisible: false,
      typeNum: 6,
      textarea: "",
      info: {},
      list: [],
      recordInfo: {
        PlateId: 0,
      }, //
      TenantTempType: [],
      TenantTempOperatorList: [],
      addFrom: {
        tempId: "",
        type: "",
        operator: "",
        title: "",
        orderSort: 0,
        time: "",
        cycleId: "",
      },
      CycleList: [],
      editFrom: {
        Content: "",
        BackCoverImg: "",
        Answer: "",
        Id: "",
      }, //去记录参数
      tableParams: {
        List: [
          {
            title: "学生表现",
            desc: "",
          },
          {
            title: "问题原因",
            desc: "",
          },
          {
            title: "解决问题计划",
            desc: "",
          },
          {
            title: "变化/成长",
            desc: "",
          },
        ],
        titleTab1: "",
        titleTab2: "",
        titleTab3: "",
        titleTab4: "",
        name: "",
        content: "",
        looktime: "",
        writename: "",
        performance: "",
        questionreason: "",
        Problemplan: "",
        change: "",
      },
      params: {
        title: "",
        List: [],
      },
      userInfo: {},
    };
  },
  components: {
    recordPlate,
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.info = JSON.parse(unescape(this.$route.query.info));
    this.WriteTempDetailList();
    this.getCycleSelect();
    this.GetTenantTempTypeInfo();
    //console.log(this.info, "this.info");
  },
  methods: {
    // 获取成长记录表2
    async GetGrowthQuestion(Ids) {
      let res = await GetGrowthQuestion({ Id: Ids });
      if (res.data.success) {
        let list = [];
        list = res.data.response.map((item) => {
          return {
            manifestation: item,
            isActivite: 1,
          };
        });
        this.params = {
          title: "",
          List: list,
        };
        //console.log(this.params);
      }
    },
    // 星星点击
    onClickRate(item, index) {
      //console.log(item, index);
      this.params.List[index].isActivite = item;
    },
    look(item) {
      //console.log(item);
      let info = {
        isPreview: true,
        Id: item.Id,
        CustomerId: this.info.CustomerId,
        TempType: this.info.TempType,
        CycleName: this.info.CycleName,
        GradeName: this.info.GradeName,
        ClassName: this.info.ClassName,
        StudentName: this.info.StudentName,
        Title: item.Title,
      };
      const href = this.$router.resolve({
        path: "/growingFootprintReport",
        query: {
          info: escape(JSON.stringify(info)),
        },
      });

      // const href = this.$router.resolve({
      //     path: "/all_result",
      //     query: {
      //       Ids: JSON.stringify(this.isChange),
      //       type: "",
      //     },
      //   });
      window.open(href.href, "_blank");
    },
    check(oneIndex, TwoIndex, ThereIndex, value) {
      this.tableData.list[oneIndex].info[TwoIndex].info[ThereIndex].Value =
        value;
    },
    record_plate_change(e) {
      console.log(e, "eeeee");
      this.editFrom.Answer = JSON.stringify(e);
    },
    /**
     * 获取操作人列表
     */
    async GetTenantTempOperatorInfo() {
      let xhr = await GetTenantTempOperatorInfo();
      if (xhr.data.success) {
        this.TenantTempOperatorList = xhr.data.response;
      } else {
        this.TenantTempOperatorList = [];
      }
    },
    // 创建
    async addFnMoudle() {
      if (this.addFrom.type === "") {
        this.$message.warning("请选择类型");
        return;
      }
      if (this.addFrom.title === "") {
        this.$message.warning("请输入标题");
        return;
      }
      if (this.addFrom.cycleId === "" && this.addFrom.type == 4) {
        this.$message.warning("请选择周期");
        return;
      }
      if (this.addFrom.time === "" && this.addFrom.type == 5) {
        this.$message.warning("请选择时间");
        return;
      }
      if (this.addFrom.operator === "") {
        this.$message.warning("请选择操作人身份");
        return;
      }
      if (this.addFrom.type != 4) {
        this.addFrom.cycleId = 0;
      }
      if (this.moduleId == "") {
        //新增
        let xhr = await AddGrowDetailOneList(this.addFrom);
        if (xhr.data.success) {
          this.$message.success("添加成功");
          this.WriteTempDetailList();
          this.addDialogVisible = false;
        } else {
          this.$message.error(xhr.data.msg);
        }
      } else {
        //修改
        let xhr = await UpdateTenantTempDetailOneInfo({
          ...this.addFrom,
          id: this.moduleId,
        });
        if (xhr.data.success) {
          this.$message.success("修改成功");
          this.WriteTempDetailList();
          this.addDialogVisible = false;
        } else {
          this.$message.error(xhr.data.msg);
        }
      }

      this.moduleId = "";
    },
    /**
     * 类型改变时触发
     */
    typeChange() {
      if (this.addFrom.type == 4) {
        this.addFrom.time = "";
      } else if (this.addFrom.type == 5) {
        this.addFrom.cycleId = "";
      } else {
        this.addFrom.time = "";
        this.addFrom.cycleId = "";
      }
    },
    /**
     * 获取类型
     */
    async GetTenantTempTypeInfo() {
      let xhr = await GetTenantTempTypeInfo();
      if (xhr.data.success) {
        this.TenantTempType = xhr.data.response;
      } else {
        this.TenantTempType = [];
      }
    },

    getCycleSelect() {
      if (this.info.CycleId == 0) {
        GetCycleInfoSelectResult({
          SchoolId: this.userInfo.SchoolId,
          StudyYearsId: this.info.StudyYearId,
        }).then((res) => {
          if (res.data.success) {
            this.CycleList = res.data.response;

            this.addFrom.cycleId = this.CycleList[0].Id;
          } else {
            this.CycleList = [];
          }
        });
      } else {
        this.CycleList = [
          {
            Id: this.info.CycleId,
            Name: this.info.CycleName,
          },
        ];
        this.addFrom.cycleId = this.info.CycleId;
      }
    },
    async record(item) {
      //console.log(item, "item");
      this.recordInfo = item;
      this.typeNum = item.Type;
      this.editFrom.Id = item.Id;
      if (this.typeNum == 4) {
        this.GoTenantTempDetailOneInfoByCycleWriteCycle(item.Id);
      } else if (this.typeNum == 5) {
        await this.GoTenantTempDetailOneInfoByCycleWrite(item.Id);
      } else {
        await this.GoTenantTempDetailOneInfoByImgTextRecord(item.Id);
      }
      this.recordDialogVisible = true;
    },

    async GoTenantTempDetailOneInfoByCycleWriteCycle(Id) {
      this.tableData = {
        list: [],
        CustomerSay: "",
        Title: "",
        cycleWrites: [],
      };
      let xhr = await GoTenantTempDetailOneInfoByCycleWriteCycle({
        Id: Id,
        StudentId: this.info.CustomerId,
      });

      if (xhr.data.success) {
        this.tableData = xhr.data.response;
      } else {
        this.editFrom = {
          Content: "",
          BackCoverImg: "",
          Answer: "",
          Id: "",
        };
        this.$message.error(xhr.data.msg);
      }
    },
    async GoTenantTempDetailOneInfoByCycleWrite(Id) {
      this.tableData = {
        list: [],
        CustomerSay: "",
        Title: "",
        cycleWrites: [],
      };
      let xhr = await GoTenantTempDetailOneInfoByCycleWrite({
        Id: Id,
        StudentId: this.info.CustomerId,
      });
      if (xhr.data.success) {
        this.tableData = xhr.data.response;
      } else {
        this.editFrom = {
          Content: "",
          BackCoverImg: "",
          Answer: "",
          Id: "",
        };
        this.$message.error(xhr.data.msg);
      }
    },
    async GoTenantTempDetailOneInfoByImgTextRecord(Id) {
      let xhr = await GoTenantTempDetailOneInfoByImgTextRecord({
        Id: Id,
        StudentId: this.info.CustomerId,
        IsWeb: 1,
      });
      if (xhr.data.success) {
        this.editFrom.Content = xhr.data.response.Content;
        this.editFrom.BackCoverImg = xhr.data.response.BackCoverImg;
        this.editFrom.Answer = xhr.data.response.Answer;
        if (xhr.data.response.Answer != "") {
          this.tableParams = JSON.parse(xhr.data.response.Answer);
        }

        if (xhr.data.response.Answer != "") {
          this.params = JSON.parse(xhr.data.response.Answer);
        } else {
          this.GetGrowthQuestion(xhr.data.response.Id);
        }
        //console.log(this.editFrom, "this.editFrom");
      } else {
        this.editFrom = {
          Content: "",
          BackCoverImg: "",
          Answer: "",
        };
        this.$message.error(xhr.data.msg);
      }
    },
    async addFn(status) {
      if (!this.checkAll() && this.typeNum == 5) {
        this.$message.warning("请完成所有的打分项");
        return;
      } else if (this.typeNum == 6) {
        if (!this.editFrom.Answer) {
          this.$message.warning("请至少上传一张图片，一段文字");
          return;
        }
        let Answer = JSON.parse(this.editFrom.Answer);
        let imageArr = Answer.filter((item) => {
          return item.Type == "image" && item.Content;
        });
        let textArr = Answer.filter((item) => {
          return item.Type == "text" && item.Content;
        });
        //console.log(imageArr, textArr);
        if (imageArr.length == 0 && textArr == 0) {
          this.$message.warning("请至少上传一张图片，一段文字");
          return;
        }
      } else if (this.typeNum == 4) {
        //学期
        let textArr = this.tableData.cycleWrites.filter((item) => {
          return item.Desc != "";
        });
        if (textArr.length == 0) {
          this.$message.warning("请填写对应内容");
          return;
        }
      } else if (this.typeNum == 1) {
        if (!this.editFrom.Answer) {
          this.$message.warning("请至少上传一张图片，一段文字");
          return;
        }
        //封面
        let Answer = JSON.parse(this.editFrom.Answer);
        if (Answer[0].Content == "") {
          this.$message.warning("请上传头像");
          return;
        }
      } else if (this.typeNum == 10) {
        if (!this.editFrom.Answer) {
          this.$message.warning("请至少上传一张图片，一段文字");
          return;
        }
        //结语
        let Answer = JSON.parse(this.editFrom.Answer);
        if (Answer[0].Content == "") {
          this.$message.warning("请填写结语");
          return;
        }
      } else if (this.typeNum == 9) {
        if (!this.editFrom.Answer) {
          this.$message.warning("请至少上传一张图片，一段文字");
          return;
        }
        // 视频
        let Answer = JSON.parse(this.editFrom.Answer);
        if (Answer[0].Content == "") {
          this.$message.warning("请上传视频");
          return;
        }
        if (Answer[1].Content == "") {
          this.$message.warning("请填写文字");
          return;
        }
      } else if (this.typeNum == 8) {
        if (!this.editFrom.Answer) {
          this.$message.warning("请至少上传一张图片，一段文字");
          return;
        }
        //体检
        let Answer = JSON.parse(this.editFrom.Answer);
        //console.log(Answer, "体检");
        let textArr = Answer.filter((item) => {
          return item.Content === "";
        });
        if (textArr.length != 0) {
          this.$message.warning("请完整填写体检记录");
          return;
        }
      } else if (this.typeNum == 7) {
        if (!this.editFrom.Answer) {
          this.$message.warning("请至少上传一张图片，一段文字");
          return;
        }
        // 运动
        let Answer = JSON.parse(this.editFrom.Answer);
        let textArr = Answer.filter((item) => {
          return item.Value === "";
        });
        if (textArr.length != 0) {
          this.$message.warning("请完整填写运动记录");
          return;
        }
      }
      let answer;
      if (this.typeNum == 11) {
        answer = JSON.stringify(this.tableParams);
      } else if (this.typeNum == 12) {
        answer = JSON.stringify(this.params);
      } else {
        answer =
          this.typeNum == 4 || this.typeNum == 5
            ? JSON.stringify(this.tableData)
            : this.editFrom.Answer;
      }
      console.log(answer, "answer");
      let xhr = await SaveDetailInfo({
        tempId: this.info.TempId,
        tempDetailId: this.editFrom.Id,
        answer: answer,
        teacherId: this.info.TeacherId,
        studentId: this.info.CustomerId,
        type: this.typeNum,
        Status:status
      });
      if (xhr.data.success) {
        this.editFrom.Content = "";
        this.editFrom.Answer = "";
        this.recordDialogVisible = false;
        this.WriteTempDetailList();
        this.$message.success("保存成功");
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    checkAll() {
      for (let i = 0; i < this.tableData.list.length; i++) {
        let one = this.tableData.list[i];
        for (let j = 0; j < one.info.length; j++) {
          let two = one.info[j];
          for (let k = 0; k < two.info.length; k++) {
            let there = two.info[k];
            if (there.Value == 0) {
              return false;
            }
          }
        }
      }

      return true;
    },
    // 自动生成
    async AutoCustomerContent() {
      if (!this.checkAll()) {
        this.$message.warning("请完成所有的打分项");
        return;
      }
      let xhr = await AutoCustomerContent({
        StudentId: this.info.CustomerId,
        tempDetailId: this.editFrom.Id,
        answer: JSON.stringify(this.tableData),
      });
      if (xhr.data.success && xhr.data.response) {
        this.tableData.CustomerSay = xhr.data.response;
      } else {
        this.$message.warning("自动生成失败");
      }
    },
    clearAddFrom() {},
    async WriteTempDetailList() {
      let xhr = await WriteTempDetailList({
        StudentId: this.info.CustomerId,
        StudentName: this.info.StudentName,
        TeacherId: this.info.TeacherId,
        TempId: this.info.TempId,
      });
      if (xhr.data.success) {
        this.list = xhr.data.response;
      } else {
        this.list = [];
      }
    },
  },
};
</script>
 
 <style scoped lang="less">
.imgFilesLists {
  display: flex;
  flex-wrap: wrap;
  .fileItem {
    width: 148px;
    height: 148px;
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    img {
      width: 30px;
      height: 30px;
    }
    .el-icon-delete {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      font-size: 30px;
      color: #cccccc;
      z-index: 10;
      cursor: pointer;
    }
  }
}

.defaultIMage {
  position: relative;
  .itemName {
    width: 100%;
    position: absolute;
    min-height: 30px;
    top: 50%;
    left: 0;
    transform: translateY(-50%) !important;
    background-color: rgba(0, 0, 0, 0.3);
    font-size: 20px;
    font-weight: 600;
    color: #444;
  }
}
// /deep/ .el-textarea__inner {
//   border: 0;
//   outline: none;
//   resize: none;
//   color: #000;
// }
// /deep/.el-input__inner::placeholder {
//   color: #000;
//   font-size: 14px;
// }
// /deep/.el-input__inner {
//   border: 0;
// }
// /deep/.el-textarea__inner {
//   border: 0;
//   color: #000;
//   resize: none; /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
//   color: #000;
//   font-size: 14px;
//   background: none !important;
// }
// /deep/.el-textarea__inner::placeholder {
//   color: #ccc;
//   font-size: 14px;
// }
/* 利用穿透，设置input边框隐藏 */
// .inputDeep >>> .el-input__inner {
//   border: 0;
// }
// /* 如果你的 el-input type 设置成textarea ，就要用这个了 */
// .inputDeep >>> .el-textarea__inner {
//   border: 0;
//   resize: none; /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
// }
.text-flex {
  width: 90px;
}
.templte {
  .add {
    display: flex;
    align-items: center;
    border: 1px solid #333;
    width: 140px;
    padding: 6px 0;
    border-radius: 10px;
    margin: 0 auto;
    justify-content: center;
    margin-top: 6px;
  }
  .flexs_dis {
    display: flex;
    justify-content: space-between;
    border: 1px dashed #333;
    margin-top: 4px;
    padding: 10px;
    border-radius: 4px;
    .li {
      font-weight: 600;
      cursor: pointer;
    }
    .icons {
      display: flex;
    }
  }
}
.btn-confirm {
  width: 290px;
  height: 50px;
  background: #4cbff4;
  color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin: 0 auto;
}
.table-input {
  // width: 100%;
  height: 30px;
}
input {
  border: 0; // 去除未选中状态边框
  outline: none; // 去除选中状态边框
  background-color: rgba(0, 0, 0, 0); // 透明背景
}
.bd-top {
  border-top: 1px solid #000000;
}

.bd-bottom {
  border-bottom: 1px solid #000000;
}

.bd-left {
  border-left: 1px solid #000000;
}

.bd-right {
  border-right: 1px solid #000000;
}
.demo-el-col {
  height: 65px;
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;

  .table-textarea {
    width: 100%;
    font-size: 10px;
    font-weight: bold;
    color: #000000;
    padding-top: 10px;
    // margin: 0 auto;
  }
}

.statueTesting {
  width: 100%;

  .statueTesting_title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #343434;
    padding-bottom: 0.25rem;

    &::before {
      content: "";
      width: 5px;
      height: 15px;
      background: #4cbff4;
      border-radius: 10px;
      display: inline-block;
      margin-right: 5px;
      position: relative;
      top: 3px;
    }
  }
}
.company-item {
  width: 58px;
  height: 29px;
  background: #4cbff4;
  border-radius: 5px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
}
.item-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  .Home-item {
    width: calc(100% / 8 - 20px);
    display: flex;
    align-items: center;
    margin: 10px;
    flex-direction: column;
    position: relative;
    background: #ffffff;
    // justify-content: center;

    .Home-time {
      position: relative;
      width: 100%;
      height: 220px;
      border: 1px solid #333333;
      color: #000;
      font-size: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      text-align: center;
      .times {
        width: 100%;
        height: 50px;
        background: rgba(52, 52, 52, 0.3);
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        color: #000;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        text-align: center;
      }
      .gray {
        /*grayscale(val):val值越大灰度就越深*/
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
      }
    }
  }
}
.hideAdd {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
.inputBox {
  display: flex;
  margin-bottom: 28px;
  .label {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    width: 100px;
    text-align: right;
  }
}
.tableHeader {
  background: #f2f5ff;
  line-height: 44px;
  text-align: center;
}
.textareaTitle {
  line-height: 44px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  padding-left: 43px;
  span {
    color: #4083fe;
  }
}
// 表格
.table {
  .textHiddent {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    line-height: 44px;
    -webkit-box-orient: vertical;
    padding: 0 10px;
    height: 44px;
    cursor: pointer;
    box-sizing: border-box;
  }
  .row {
    display: flex;
  }
  .tableHeader {
    background: #f2f5ff;
    line-height: 44px;
  }
  .cell {
    box-sizing: border-box;
    text-align: center;
    width: 100%;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .border_bottom {
    border-bottom: solid 1px #ededed;
  }
  .border_top {
    border-top: solid 1px #ededed;
  }
  .border_left {
    border-left: solid 1px #ededed;
  }
  .border_right {
    border-right: solid 1px #ededed;
  }
  .lineOne {
    width: 236px;
  }
  .lineTwo {
    width: 338px;
    display: flex;
  }
  .lineThere {
    flex: 1;
  }
  .lineFour {
    width: 200px;
    // flex: 1;
  }
  .grade {
    width: 131px;
    .check {
      width: 18px;
      height: 18px;
      background: #22bbcb;
      display: block;
      border-radius: 50%;
    }
    .noCheck {
      width: 18px;
      height: 18px;
      background: #cdcdcd;
      display: block;
      border-radius: 50%;
    }
  }
}

.recordBody {
  padding: 20px;
  box-sizing: border-box;
  .line {
    background-color: #fff;
    padding: 12px 25px;
    margin-top: 15px;
    .rowTop {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 500;
      color: #666666;
      line-height: 22px;
      margin-bottom: 20px;
    }
    .rowCenter {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
      margin-bottom: 17px;
    }
    .rowBottom {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
      cursor: pointer;
    }
  }
}
</style>